const translations = require('../../assets/configs/babel/fr.json')
const _ = require('lodash')

const tmpBabel = require('../tmpBabel.json')

// sometimes webpacker in production doesn't rebuild babel
const forceRebuildToken = require('../forceBabelRebuild')

window.__localization = {
  locale: 'fr',
  translations: _.merge({}, {fr: tmpBabel["fr"]}, translations)
}
